var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.602 2.703L4.722.063C4.652 0 4.55-.018 4.464.02 4.376.06 4.32.145 4.32.24v5.28c0 .095.056.182.144.22.03.013.063.02.096.02.059 0 .117-.021.162-.063l2.88-2.64c.05-.045.078-.11.078-.177 0-.067-.028-.131-.078-.177zM3.216.02C3.13-.018 3.028 0 2.958.063l-2.88 2.64C.028 2.75 0 2.813 0 2.88c0 .067.028.132.078.177l2.88 2.64c.045.042.103.063.162.063.033 0 .066-.007.096-.02.088-.038.144-.125.144-.22V.24c0-.095-.056-.181-.144-.22z",
    transform: "rotate(90 2.993 2.993)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.ca817aeaa774634ccfec043033f12477.svg";
export { ForwardRef as ReactComponent };